module.exports = __webpack_public_path__ + "img/E-commerce.44556ddf.webp";